import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { newModalStyle } from "../../reusable/styles";
import Style from "./modalResetTicket.module.css";
import Button from "../../common/button/button";
import CancellationReasonSelect from "./cancellationReasonSelect";

const ModalRefundTicket = (props) => {
  const { t } = useTranslation();
  const [cancellationReason, setCancellationReason] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const confirm = async () => {
    setSubmitting(true);
    try {
      await props.onConfirm(cancellationReason);
    } catch (e) {
      // the action already showed the error notification; stay open so the operator can retry
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={props.open}
      closeOnEsc={!submitting}
      closeOnOverlayClick={!submitting}
      showCloseIcon={!submitting}
      onClose={props.close}
      center
      styles={newModalStyle({ width: "450px" })}
    >
      <div className="modal__title">
        {t("ModalRefundTicket.title")}
      </div>

      <div style={{ marginTop: 20 }}>
        <div style={{ marginTop: 10, fontSize: 15 }}>
          {t("ModalRefundTicket.areYouSure")}
        </div>

        <div style={{ marginTop: 5, fontSize: 14, color: "#666" }}>
          {t("ModalRefundTicket.ticketNumber")}: <b>{props.ticket?.number}</b>
        </div>

        <CancellationReasonSelect
          ticket={props.ticket}
          value={cancellationReason}
          onChange={setCancellationReason}
        />
      </div>

      <div className={Style.buttonContainer} style={{ marginTop: 30 }}>
        <Button
          style={{ width: "35%" }}
          buttonStyle={{ width: "100%" }}
          variant="secondary"
          text={t("ModalRefundTicket.cancel")}
          disabled={submitting}
          onClick={props.close}
        />

        <Button
          style={{ width: "35%" }}
          buttonStyle={{ width: "100%" }}
          text={t("ModalRefundTicket.refund")}
          disabled={submitting || !cancellationReason}
          onClick={confirm}
        />
      </div>
    </Modal>
  );
};

export default ModalRefundTicket;
